module.exports = __webpack_public_path__ + "custom-select.33d0b67c047e466b46c4.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/images/custom-select.png
// module id = ../../../../../src/assets/images/custom-select.png
// module chunks = styles